module.exports = __webpack_public_path__ + "img/giftPink.8f890d3c.svg";